export default __webpack_public_path__ + "static/media/Video1.665e7e19.mp4";